import { Injectable } from "@angular/core";
import { NetworkService } from "../../../app/shared/network.service";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  constructor(private _networkService: NetworkService) {}
  getSupportList(query) {
    // console.log("getTripList");
    return this._networkService.get(
      "api/support?" + query,
      null,
      null,
      "bearer"
    );
  }
}
